/* Draws heavy influence from https://web.dev/building-a-toast-component/ */
const Toaster = document.querySelector('[data-kui-toaster]');

const cloneToastTemplate = (msg, type) => {
    const template = document.querySelector('[data-kui-toast-template]');
    const clone = template.content.cloneNode(true);
    const containerEl = clone.querySelector(':first-child');
    const msgEl = clone.querySelector('[data-kui-toast-msg]');

    containerEl.classList.add(`kui-toast--${type}`);
    containerEl.setAttribute(`data-kui-toast-${type}`, 'true');
    msgEl.textContent = msg;

    return clone;
};

const addToQueue = (toast) => {
    const first = Toaster.offsetHeight;
    Toaster.appendChild(toast);
    const last = Toaster.offsetHeight;
    const invert = last - first;

    Toaster.animate(
        [{transform: `translateY(${invert}px)`}, {transform: 'translateY(0)'}],
        {
            duration: 150,
            easing: 'ease-out'
        }
    );
};

const addToast = (toast) => {
    const {matches: motionOK} = window.matchMedia(
        '(prefers-reduced-motion: no-preference)'
    );

    Toaster.children.length && motionOK
        ? addToQueue(toast)
        : Toaster.appendChild(toast);
};

const removeLoaderToast = () => {
    if (!Toaster) {
        return;
    }

    const toastEl = Toaster.querySelector(
        '[data-kui-toast-loader]:first-child'
    );

    if (toastEl) {
        Toaster.removeChild(toastEl);
    }

    document.documentElement.classList.remove('is-loading');
};

const showToast = (res) => {
    const {message, type = 'success'} = res;
    const clone = cloneToastTemplate(message, type);
    const isLoader = type === 'loader';

    if (isLoader) {
        Toaster.appendChild(clone);
    } else {
        addToast(clone);

        const toastEl = Toaster.querySelector('[data-kui-toast]:last-child');
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve) => {
            await Promise.allSettled(
                toastEl.getAnimations().map((animation) => animation.finished)
            );
            Toaster.removeChild(toastEl);
            resolve();
        });
    }
};

const toast = (res = {}) => {
    if (!Toaster) {
        return;
    }

    showToast(res);
};

export {toast, removeLoaderToast};
